export const CAPTION = `WEBVTT`;
export const CAPTION_HEADER = `WEBVTT FILE`;
export const PLACEHOLDER = `{xazqby}`;
export const isCdkEnvironment = import.meta.env.VITE_WHITELABEL_NAME === 'cdk';

export const VAULT_FOLDER = 'vault';
